var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showMeasuringTool
    ? _c("div", { staticClass: "measurement-widget" }, [
        _c(
          "div",
          { staticClass: "measurement-header" },
          [
            _c("fa", {
              staticClass: "measurement-header-icon",
              attrs: { icon: ["fas", "ruler"], size: "sm" },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "measurement-header-label" }, [
              _vm._v("Measurement"),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "measurement-body" }, [
          _c("div", { staticClass: "measurement-row" }, [
            _c("span", { staticClass: "measurement-key" }, [_vm._v("Length")]),
            _vm._v(" "),
            _c("span", { staticClass: "measurement-val" }, [
              _vm._v(
                _vm._s(_vm.measurement[0]) + " " + _vm._s(_vm.measurement[1])
              ),
            ]),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }